var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isToggle)?_c('div',[(_vm.$mq.md)?_c('desktop-slide-show',{attrs:{"dimension-icon":_vm.dimensionIcon}}):_c('mobile-slide-show',{attrs:{"dimension-icon":_vm.dimensionIcon}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }